<div class="breadcrumbs-container">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <div class="breadcrumb" [class.clickable]="!last" (click)="navigate(breadcrumb)">{{breadcrumb.text}}</div>
    <i *ngIf="!last" class="fas fa-chevron-right"></i>
  </ng-container> 
</div>